//Customer Permissions
var READ_CUSTOMER = 'read:customer';
var NEW_CUSTOMER = 'new:customer'; //Quotation Permissions

var QUOTES = 'quotes'; //Proposal Permissions

var PROPOSAL = 'proposal'; //Policy Permissions

var READ_POLICY = 'read:policy';
var RENEW_POLICY = 'renew:policy';
var ENDORSE_POLICY = 'endorse:policy'; //Endorsement Permissions

var NEW_ENDORSMENT = 'new:endorsement'; //Payment Permissions

var READ_PAYMENT = 'read:payment';
var CDACCOUNTS_PAYMENT = 'cd-accounts:payment';
var GENERATE_PAYSLIP = 'generate-payslip';
var DOWNLOAD_PAYSLIP = 'download-payslip'; //Claims Permissions

var CLAIMS = 'claims'; //User Profile Permissions

var PROFILE_USER = 'profile:user'; //Sales Dashboard Permissions

var DASHBOARD = 'dashboard'; //Mis-Report Permissions

var MIS_REPORTS = 'mis-reports'; //Chat&Mail Permissions

var WEB_CHAT = 'web-chat';
var INBOX = 'inbox'; //User Role Permissions

var ROLE_USER = 'roles:user'; //User Management Permissions

var NEW_EXTERNAL_USER = 'new-external:user';
var EDIT_EXTERNAL_USER = 'edit-external:user';
var NEW_INTERNAL_USER = 'new-internal:user';
var EDIT_INTERNAL_USER = 'edit-intermal:user';
var PERMISSIONS_USER = 'permissions:user';
var SWITCH_ROLE = 'switch-role:user';
var MANAGE_INTERMEDIARY_USER = 'manage-intermediary:user';
var SEARCH_USER = 'search:user';
var FINANCER_DETAILS = 'financer-detail'; //sec_perms- finance-detail

var MANAGE_LIMITS = 'business-limit:user'; // product level UW

var CREATE_PRODUCT_LEVEL_UW = 'create:product-level-uw';
var READ_PRODUCT_LEVEL_UW = 'read:product-level-uw';

export { CDACCOUNTS_PAYMENT, CLAIMS, CREATE_PRODUCT_LEVEL_UW, DASHBOARD, DOWNLOAD_PAYSLIP, EDIT_EXTERNAL_USER, EDIT_INTERNAL_USER, ENDORSE_POLICY, FINANCER_DETAILS, GENERATE_PAYSLIP, INBOX, MANAGE_INTERMEDIARY_USER, MANAGE_LIMITS, MIS_REPORTS, NEW_CUSTOMER, NEW_ENDORSMENT, NEW_EXTERNAL_USER, NEW_INTERNAL_USER, PERMISSIONS_USER, PROFILE_USER, PROPOSAL, QUOTES, READ_CUSTOMER, READ_PAYMENT, READ_POLICY, READ_PRODUCT_LEVEL_UW, RENEW_POLICY, ROLE_USER, SEARCH_USER, SWITCH_ROLE, WEB_CHAT };
